export enum ActionType {
  DOCUMENTS_UPLOAD_BY_PID = "DOCUMENTS_UPLOAD_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IDocumentsUploadByPid {
  type: ActionType.DOCUMENTS_UPLOAD_BY_PID;
  payload: any;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IDocumentsUploadByPid | IResetReduxState;
